<template>
    <div class="wrapper watchlist-page">
        <div>
        <div class="columns watchlist-content">
            <div class="column is-12-mobile is-9">
                <div class="columns is-flex">
                    <div class="column is-6 is-align-self-center">
                        <back-button></back-button>
                    </div>
                </div>
                <div class="columns is-flex">
                    <div class="column is-align-self-center">
                        <div class="is-flex is-align-items-center">
                            <h1 class="title-page is-size-5 is-size-4-desktop has-text-weight-bold mr-5">My Watchlists
                            </h1>
                            <b-button @click="createWatchClick" type="is-primary" class="is-uppercase is-size-7" style="height:40px">Create new</b-button>
                            <div class="is-hidden-mobile mt-1 ml-5 "><page-help :height="'560px'" :pageHelp="'watchlist'"/></div>
                            <a href="/popular-top-funds" class="is-hidden-mobile button is-uppercase ml-5 is-size-7 is-primary bg-green" style="height: 40px;" target="_blank"><span>Popular Top funds</span></a>
                        </div>
                        <h2 class="is-size-5 has-text-weight-bold is-white-space-nowrap mt-5 is-hidden-mobile">Select</h2>
                        <h2 class="is-size-5 is-white-space-nowrap mt-5 is-hidden-tablet">Select</h2>
                        <div class="is-flex">
                            <div class="select-wrapper featured is-justify-content-left">
                                <b-select
                                    class="mr-1 is-flex-grow-0 select-watchlist"
                                    v-model="currentWatchlist"
                                    placeholder="Select a name"
                                    style="min-width:120px"
                                >
                                    <option v-for="item in myWatchlists" :key="item.id" :value="item">
                                        {{ item.name }}
                                    </option>
                                </b-select>
                                <span class="mr-2 cursor-pointer" @click="isModalEditWatchlist = !isModalEditWatchlist">
                                    <img src="/img/edit-pen.svg" class="edit-pen-icon">
                                </span>
                                <span class="cursor-pointer" @click="() => removeWatchlist(currentWatchlist)"><b-icon icon="close" size="is-small" class="red"></b-icon></span>
                            </div>
                            <div class="m-l-20 see-returns is-hidden-tablet">
                                <currency-toggle :class="{'ccy-disabled': ccyDisabled}" @currency-change="currencyChange"/>
                            </div>
                            <button class="m-l-20 btn btn-clear is-hidden-mobile" @click="addNewFundClick">ADD NEW FUNDS</button>
                        </div>
                    </div>
                </div>
                <!-- <div class="column background-color-white p-5 overflow-hidden watchlist-box is-hidden-mobile">
                    <button id="scrollToFundListBtn" class="is-hidden" v-scroll-to="'#myWatchlists'">
                        Scroll to Watchlists
                    </button>
                    <div v-if="myWatchlists && myWatchlists.length">
                        <div class="watch-lists-page watch-lists pt-4">
                            <template v-for="(item, index) in myWatchlists">
                                <div :key="index" class="watch-lists-item">
                                    <div class="p-2">
                                        <div class="p-4 box-my-watchlist" :class="`background-watchlist-${index}`">
                                            <span @click="removeWatchlist(item)"><b-icon icon="close" size="is-small" class="white-text btn-close cursor-pointer"></b-icon></span>
                                            <div @click="changeCurrentWatchlist(item)" class="text-box is-uppercase has-text-weight-bold white-text is-size-7 cursor-pointer"><span class="cursor-pointer">{{item.name}}</span></div>
                                        </div>

                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div> -->

                <!-- v-if="myWatchlists.length>0"  -->
                <div class="columns mt-3">
                    <div class="column is-12">
                        <div id="myWatchlists" class="columns is-flex-mobile is-hidden-mobile">
                            <div class="column is-6-mobile is-12">
                                <div class="is-12 mt-1">
                                    <div class="is-flex is-flex-direction-row is-align-content-center filters-watchlist">
                                        <div class="is-flex is-flex-direction-column">
                                            <h2 class="is-size-5 is-size-5-desktop has-text-weight-bold is-white-space-nowrap mb-1">Sort by</h2>
                                            <div class="is-flex is-flex-direction-row is-align-content-center">
                                                <div class="is-flex is-flex-direction-column">
                                                    <b-dropdown :disabled="selectedFund.length>0?false:true" aria-role="list" class="mr-3" v-model="sorting1">
                                                        <button class="button is-primary" slot="trigger" slot-scope="{ active }">
                                                            <span>{{sorting1.text ? sorting1.text : 'Level 1'}}</span>
                                                            <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                                                        </button>
                                                        <b-dropdown-item aria-role="listitem" v-for="(i, index) in sortinglist1" :value="i" :key="index" :disabled="!i.sortable">{{i.text}}</b-dropdown-item>
                                                    </b-dropdown>
                                                    <div class="mt-2">
                                                        <b-select :disabled="selectedFund.length>0?false:true" class="sort-select-2" v-model="sortDir1" placeholder="-- select --">
                                                            <option v-for="(item, index) in sortingType1" :value="item.value" :key="index">{{item.text}}</option>
                                                        </b-select>
                                                    </div>
                                                </div>
                                                <div class="is-flex is-flex-direction-column">
                                                    <b-dropdown :disabled="!showSecondOption || selectedFund.length === 0" aria-role="list" class="mr-3" v-model="sorting2">
                                                        <button class="button is-primary" slot="trigger" slot-scope="{ active }">
                                                            <span>{{sorting2.text ? sorting2.text : 'Level 2'}}</span>
                                                            <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                                                        </button>
                                                        <b-dropdown-item aria-role="listitem" v-for="(i, index) in sortinglist2" :value="i" :key="index" :disabled="!i.sortable">{{i.text}}</b-dropdown-item>
                                                    </b-dropdown>
                                                    <div class="mt-2">
                                                        <b-select :disabled="!showSecondOption || selectedFund.length === 0" class="sort-select-2" v-model="sortDir2" placeholder="-- select --">
                                                            <option v-for="(item, index) in sortingType2" :value="item.value" :key="index">{{item.text}}</option>
                                                        </b-select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="is-flex is-flex-direction-column is-flex-grow-1 p-l-50">
                                            <div class="is-flex is-flex-direction-row is-align-content-center">
                                                <div class="is-flex is-flex-direction-column pr-3 is-relative">
                                                    <h2 class="is-size-5 is-size-5-desktop has-text-weight-bold is-white-space-nowrap mb-1">For NTRs / OGC / 3Y SD display</h2>
                                                    <b-dropdown aria-role="list" class="dropdown-display" v-model="displaying">
                                                        <button class="button is-primary" slot="trigger" slot-scope="{ active }">
                                                            <span>{{displaying.text ? displaying.text : 'Value'}}</span>
                                                            <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                                                        </button>
                                                        <b-dropdown-item v-on:click="change_field(6,displaying)" aria-role="listitem" v-for="(i, index) in comboDisplay" :value="i" :key="index">{{i.text}}</b-dropdown-item>
                                                    </b-dropdown>
                                                    <b-tooltip  v-if="tooltipShow" class="referral-tooltip" always html>
                                                        <div class="is-relative">
                                                            <span class="close-tooltip" @click="tooltipShow=false">X</span>
                                                            Use this menu to see in your watchlist <br>
                                                            > your funds position versus its category peers <br>
                                                            > the difference between your fund and the best fund in its category <br>
                                                            > the difference between your fund and the median fund in its category
                                                        </div>
                                                    </b-tooltip>
                                                </div>
                                                <div class="is-hidden-mobile is-flex-grow-1	is-flex-direction-column is-flex is-justify-content-right is-align-items-end see-returns">
                                                    <h2 class="is-size-5 is-size-5-desktop has-text-weight-bold is-white-space-nowrap mb-1">&nbsp;</h2>
                                                    <currency-toggle :class="{'ccy-disabled': ccyDisabled}" @currency-change="currencyChange"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div ref="refWatchlistTable" class="columns is-relative">
                    <div v-if="!tooltipShow" class="is-flex is-justify-content-space-between pl-3 pr-3 is-align-items-center is-hidden-tablet m-b-20">
                         <button class="btn btn-clear mr-2" @click="addNewFundClick">ADD NEW FUNDS</button>
                        <p class="has-text-center is-size-7-mobile grey-text-2"><img src="/img/h-scroll.svg" class="h-scroll-icon"> Swipe table to see more</p>
                    </div>
                    <div class="column is-12 px-0-tablet p-r-15-tablet p-l-15-tablet">
                        <div class="scroll-table-wrapper distance-table overflow-x-auto">
                            <table class="watchlist-table alerts-table-1">
                                <thead>
                                    <tr>
                                        <td>N</td>
                                        <td>ISIN</td>
                                        <td>CCY</td>
                                        <td>
                                            <div class="sprd-vs-title">SPRD VS</div>
                                        </td>
                                        <td v-for="n in 5" :key="n">
                                            <b-dropdown :scrollable="true" :max-height="isMobile()?400:300" :append-to-body="true" aria-role="list" class="attribute-dropdown">
                                                <button class="button is-primary" slot="trigger" slot-scope="{ active }">
                                                    <span>{{selected_fs['selected_f'+n].code==='ChangeInPrice'?'1 Day Move':selected_fs['selected_f'+n].text}}</span>
                                                    <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                                                </button>
                                                <b-dropdown-item aria-role="listitem" v-for="(option, index) in current_fields" v-bind:value="option.ID" v-on:click="change_field(n,option)" :key="index">{{ option.text }}</b-dropdown-item>
                                            </b-dropdown>
                                        </td>
                                        <td></td>
                                    </tr>
                                </thead>

                                <tbody>
                                <template  v-for="(i, index) in selectedFund">
                                    <tr v-bind:class="(index == 0)?'wh':''" :key="index">
                                        <td class="full-column" colspan="9">
                                            <div class="is-flex is-align-items-center" style="gap: 10px;">
                                                <span class="has-text-weight-bold">
                                                    <router-link class="has-text-underline" :to="{name:'Detailedview Results',params:{id:i.ISIN, text: convertURL(i.am_short || '')},query:{source:'watchlist', id: currentWatchlist.id}}">
                                                            {{ i.FundBasicsName }}
                                                    </router-link>
                                                    <button v-tooltip="{content: 'Click to see Fund details', trigger: 'hover click'}">?</button>
                                                </span>
                                                <b-dropdown class="dropdown-blog" v-if="i.blogs" aria-role="list">
                                                    <button class="font-weight-700 text-blue btn-blog" slot="trigger">
                                                        <span @click="getBlog(i.fund_id)">Blog</span>
                                                    </button>
                                                    <b-dropdown-item v-for="(blog, index) in fundsWithBlogs" class="is-flex-wrap-nowrap" :key="index" aria-role="listitem" :href="blog.bloglink" target="_blank">
                                                        <span class="mdi mdi-circle"></span>
                                                        {{ blog.blogtitle }} ({{formatDateTime(blog.blogdate,'yyyy-MM-DD')}})
                                                    </b-dropdown-item>
                                                </b-dropdown>
                                                <b-dropdown class="dropdown-blog" v-if="i.news" aria-role="list">
                                                    <button class="font-weight-700 text-blue btn-blog" slot="trigger">
                                                        <span @click="getNews(i.fund_id)">News</span>
                                                    </button>
                                                    <b-dropdown-item v-for="(news, index) in fundsWithNews" class="is-flex-wrap-nowrap" :key="index" aria-role="listitem" :href="news.newslink" target="_blank">
                                                        <span class="mdi mdi-circle"></span>
                                                        {{ news.newstitle }} ({{ formatDateTime(news.newsdate,'yyyy-MM-DD') }} | {{ news.newspublisher }})
                                                    </b-dropdown-item>
                                                </b-dropdown>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-bind:class="(index == 0)?'wh':''" :key="index">
                                        <td><span>{{index+1}}</span></td>
                                        <td><span>{{i.ISIN}}</span></td>
                                        <td><span>{{i.CurrencyId}}</span></td>
                                        <td>
                                            <b-dropdown id="dropdown-sprd-vs" :scrollable="true" :max-height="isMobile()?400:300" :append-to-body="true" aria-role="list" class="attribute-dropdown">
                                                <button class="button is-primary box-shadow-style-c" :class="i.bmarkISIN ? '': 'btn-default'" :ref="'buttonBenchmark_' + i.ISIN" slot="trigger" slot-scope="{ active }">
                                                    <span class="dropdown-caption" :ref="'benchmark_' + i.ISIN">{{ i.bmarkISIN ? listBenchmark.find(item => item.ISIN === i.bmarkISIN).description : "Select B'mark" }}</span>
                                                    <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                                                </button>
                                                <b-dropdown-item aria-role="listitem" v-on:click="changeBenchmark('benchmark_' + i.ISIN, i, undefined)" :key="idx">Select B'mark</b-dropdown-item>
                                                <b-dropdown-item aria-role="listitem" v-for="(option, idx) in listBenchmark" v-bind:value="option.ISIN" v-on:click="changeBenchmark('benchmark_' + i.ISIN, i, option)" :key="idx">{{ option.description }}</b-dropdown-item>
                                            </b-dropdown>
                                        </td>
                                        <td v-for="n in 5" :key="n">
                                            <span :class="{red: i[selected_fs['selected_f'+n].code] < 0}" v-if="i[selected_fs['selected_f'+n].code]!=null || checkNTRs(selected_fs['selected_f'+n].code)">
                                                <template v-if="checkNTRs(selected_fs['selected_f'+n].code)">
                                                    <div v-if="displaying.code === 'rank'">
                                                        <div  class="dark-text" v-if="i[displayFilter['rank' + selected_fs['selected_f'+n].code]] != null && i[displayFilter['num' + selected_fs['selected_f'+n].code]] != null">
                                                            {{ `${i[displayFilter['rank' + selected_fs['selected_f'+n].code]]} Out of ${i[displayFilter['num' + selected_fs['selected_f'+n].code]]}` }}
                                                        </div>
                                                        <div v-else style="color: #999">n/a</div>
                                                    </div>
                                                    <div v-else-if="displaying.code === 'best' || displaying.code === 'median'" :class="{ 'dark-text': i[displayFilter[displaying.code + selected_fs['selected_f'+n].code]] == null || i[selected_fs['selected_f'+n].code] == null }">
                                                        <div :class="[
                                                            {red: i[displayFilter[displaying.code + selected_fs['selected_f'+n].code]] < 0},
                                                            {'dark-text': i[displayFilter[displaying.code + selected_fs['selected_f'+n].code]] > 0}
                                                            ]"
                                                             v-if="i[displayFilter[displaying.code + selected_fs['selected_f'+n].code]] != null">
                                                            {{ Number(i[displayFilter[displaying.code + selected_fs['selected_f'+n].code]]).toFixed(2) + '%' }}
                                                        </div>
                                                        <div v-else style="color: #999">n/a</div>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <template v-if="selected_fs['selected_f'+n].code == 'fundnetassetgbp'">
                                                        {{ currency("GBP", parseNA(i[selected_fs['selected_f'+n].code])) }}m
                                                    </template>
                                                    <template v-else>
                                                        <span v-if="selected_fs['selected_f'+n].code == 'IndexFund'" class="ws-style" :class="i[selected_fs['selected_f'+n].code] | numbersformat(selected_fs['selected_f'+n].code)">
                                                            {{ i[selected_fs['selected_f'+n].code] | numbersformat(selected_fs['selected_f'+n].code)}}
                                                        </span>
                                                        <span v-else-if="selected_fs['selected_f'+n].code == 'LegalStructure'">
                                                            {{ i[selected_fs['selected_f'+n].code] | stringFormat(selected_fs['selected_f'+n].code)}}
                                                        </span>
                                                        <span v-else>
                                                            {{ i[selected_fs['selected_f'+n].code] | numbersformat(selected_fs['selected_f'+n].code)}}{{selected_fs['selected_f'+n].code | findUnit}}
                                                        </span>
                                                    </template>
                                                </template>

                                            </span>
                                            <span v-else style="color: #999">n/a</span>
                                            <div v-show="displaying.code == 'value' && ['CumulativeTotalReturn1Year', 'CumulativeTotalReturnTD', 'TotalReturn3Years', 'TotalReturn5Years'].includes(selected_fs['selected_f'+n].code)">
                                                <span 
                                                    :ref="i.ISIN + 'benchmark_f' + n"
                                                    style="background-color: rgb(255, 254, 0);"
                                                    :class="{red: i.bmarkISIN 
                                                        ? i[selected_fs['selected_f'+n].code] 
                                                            ? parseFloat(i[selected_fs['selected_f'+n].code] - listBenchmark.find(item => item.ISIN === i.bmarkISIN)[benchmark[selected_fs['selected_f'+n].code]]) < 0
                                                            : false 
                                                        : false }"
                                                >
                                                {{  i.bmarkISIN 
                                                        ? i[selected_fs['selected_f'+n].code] 
                                                            ? parseFloat(i[selected_fs['selected_f'+n].code] - listBenchmark.find(item => item.ISIN === i.bmarkISIN)[benchmark[selected_fs['selected_f'+n].code]]).toFixed(2) + '%'
                                                            : '' 
                                                        : '' 
                                                }}    
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <buttons :class="'btn-small abc'" @getFundByIdWatchlist="getFundByIdWatchlist(currentWatchlist.id, true)" :isDeleteFund="true" :ISIN="i.ISIN" :fundId="i.fund_id" :fund_data="i"/>
                                        </td>
                                    </tr>
                                </template>
                                    <tr v-if="selectedFund.length===0" class="wh">
                                        <td class="full-column p-4" colspan="9">
                                            <span>{{noAvailabledFund}}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="columns is-mobile">
                    <div class="column is-12-tablet disclaimer">
                        <Disclaimer />
                    </div>
                </div>
            </div>

            <div ref="subRight_before" class="column is-12-mobile is-3-widescreen banner-right">
                <div class="banner-on-top" ref="subRight">
                    <!-- <AdsGoogle /> -->
                     <AdsPartner/>
                </div>
            </div>

        </div>
    </div>
    <b-modal has-modal-card
            :full-screen="isMobile()?true:false"
            can-cancel="outside"
            v-model="isModalCreatedWatchlist"
            :width="640">
            <watchlist-modal></watchlist-modal>
    </b-modal>

    <b-modal
            v-if="currentWatchlist && currentWatchlist.name"
            has-modal-card
            :full-screen="isMobile()?true:false"
            can-cancel="outside"
            v-model="isModalEditWatchlist"
            :width="640">
            <edit-watchlist-modal
            @update:name="currentWatchlist.name = $event"
            :watchListName="currentWatchlist.name"
            :id="currentWatchlist.id"></edit-watchlist-modal>
    </b-modal>

        <b-modal
            v-model="isCardModalActive"
            has-modal-card
            trap-focus
            :destroy-on-hide="false"
            aria-role="dialog"
            aria-label="Example Modal"
            aria-modal>
            <template >
                <div class="modal-card" style="width: auto">
                    <header class="modal-card-head">
                        <p class="modal-card-title">SORT BY</p>
                        <button
                            type="button"
                            class="delete"
                            @click="isCardModalActive=false"/>
                    </header>
                    <section class="modal-card-body">
                        <ul class="sort-links is-justify-content-flex-start">
                            <li>
                                <div class="columns px-3 mt-2">
                                    <div>
                                        <label class="mb-2 is-block">Level 1</label>
                                        <b-select
                                            :disabled="selectedFund.length > 0 ? false : true"
                                            label="Level 1"
                                            class="sort-select-1"
                                            v-model="sorting1"
                                            expanded
                                            style="min-width:145px"
                                            placeholder="-- select --"
                                        >
                                            <option
                                                v-for="(i, index) in sortinglist1" :value="i" :key="index" :disabled="!i.sortable">
                                                {{ i.text }}
                                            </option>
                                        </b-select>
                                        <b-select class="sort-select-2" v-model="sortDir1" placeholder="-- select --">
                                            <option v-for="(item, index) in sortingType1" :value="item.value" :key="index">{{item.text}}</option>
                                        </b-select>
                                    </div>
                                    <div class="ml-3 m-l-0-mobile" v-if="showSecondOption">
                                        <label class="mb-2 is-block">Level 2</label>
                                        <b-select
                                            :disabled="!showSecondOption"
                                            label="Level 2"
                                            class="sort-select-1"
                                            v-model="sorting2"
                                            expanded
                                            style="min-width:145px"
                                            placeholder="-- select --"
                                        >
                                            <option
                                                v-for="(i, index) in sortinglist2" :value="i" :key="index" :disabled="!i.sortable">
                                                {{ i.text }}
                                            </option>
                                        </b-select>
                                        <b-select :disabled="!showSecondOption" class="sort-select-2" v-model="sortDir2" placeholder="-- select --">
                                            <option v-for="(item, index) in sortingType2" :value="item.value" :key="index">{{item.text}}</option>
                                        </b-select>
                                    </div>
                                </div>
                            </li>

                            <li class="mr-0">
                                <div class="m-t-45">
                                    <a class="clear-btn" @click="clearSorting(1)">Clear</a>
                                </div>
                                <div v-if="showSecondOption" class="m-t-100">
                                    <a class="clear-btn" @click="clearSorting(2)">Clear</a>
                                </div>
                            </li>
                        </ul>
                        <div class="is-flex is-justify-content-center">
                            <button
                                type="button"
                                class="button is-primary"
                                @click="isCardModalActive=false">Apply</button>
                        </div>
                    </section>
                </div>
            </template>
        </b-modal>
        <div class="mobile-filters-watchlist is-hidden-tablet">
            <a @click="isCardModalActive = true" >SORT</a>
        </div>
    </div>
</template>
<style scoped lang="scss">
.dropdown-blog .dropdown-menu {
    max-width: 500px;
}
.watchlist-table .dropdown-caption {
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
}
#dropdown-sprd-vs button {
    background-color: rgb(255, 254, 0) !important;
    border: 1px solid rgb(255, 254, 0);
    &:hover {
        color: #000;
    }
}
.sprd-vs-title {
    background: yellow;
    color: black;
    padding: 5px 0;
    margin: 0 15px;
}
#dropdown-sprd-vs button.btn-default {
    background: transparent !important;
    border: 1px solid #000;
}
.btn-disabled, ::v-deep.ccy-disabled label {
    pointer-events: none;
}
#dropdown-sprd-vs.btn-disabled button.btn-default,
#dropdown-sprd-vs.btn-disabled button {
    background: #ccc !important;
    border: 1px solid #ccc;
}
::v-deep .sort-select-2 .select {
    width: 100%;
}
::v-deep .sort-select-2 .select select {
    width: calc(100% - 0.25rem) !important; 
}
.dropdown-display::v-deep .dropdown-trigger {
    width: 100%;
}
.dropdown-display::v-deep .dropdown-trigger .button  {
    width: 100%;
    justify-content: space-between;
}

::v-deep.ccy-disabled .switch input[type=checkbox] + .check {
    background: darkgrey !important;
}

::v-deep .b-tooltip .tooltip-trigger {
    font-size: 20px;
    padding: 20px;
    font-weight: 700;
    background: #ff0;
    border: 1px solid #153647;
    color: #153647;
    width: fit-content;
    white-space: inherit;
    line-height: 1.2;
    box-shadow: 0 1px 2px 1px rgba(0,1,0,.2);
    border-radius: 6px;
}
::v-deep .tooltip-content {
    display: none;
}
.referral-tooltip {
    position: absolute;
    top: calc(100% + 5px);
    z-index: 11;
    right: 50%;
    width: 220%;
    transform: translateX(50%);
}
::v-deep .b-tooltip .tooltip-trigger:before {
    border-top-color: #4855da;
    top: auto;
    bottom: 100%;
    border-bottom: 10px solid #4855da;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
    right: auto;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    position: absolute;
    content: "";
    pointer-events: none;
    z-index: 38;
}
.close-tooltip {
    position: absolute;
    right: 0;
    top: -10px;
    cursor: pointer;
}
@media (max-width: 768px) {
    .distance-table {
        margin-left: 0 !important;
        width: 100% !important;
    }
    .referral-tooltip {
        padding-right: 1rem;
    }
}
.btn-blog {
    background: #b9ede8;
    padding: 10px;
    border: none;
    color: #009BDE;
    font-size: 1em;
}
.dropdown-blog:hover {
    background: #fff !important;
}
.dropdown-blog a {
    flex-wrap: wrap;
    white-space: normal;
    text-align: left;
    width: 500px;
    padding: 10px;
    max-width: 100%;
    color: #009BDE;
}
.dropdown-item .mdi-circle {
    font-size: 10px;
    min-width: 10px;
}
.dropdown-item:hover .mdi-circle {
    color: inherit;
}
</style>

<script>
import axios from "axios";
import { mapState } from 'vuex'
import BackButton from '@/components/BackButton.vue';
import commonMixin from "@/mixins/commonMixin";
import bannerMixin from "@/mixins/bannerMixin";
import Buttons from '@/components/Buttons.vue';
import CurrencyToggle from "@/components/CurrencyToggle";
import compositeMixin from "@/mixins/compositeMixin";
import WatchlistModal from '@/components/WatchlistModal.vue';
import EditWatchlistModal from '@/components/EditWatchlistModal.vue';
import Disclaimer from "@/components/Disclaimer"
import PageHelp from '@/components/PageHelp.vue';
import AdsGoogle from '@/components/AdsGoogle.vue';
import AdsPartner from "@/components/AdsPartner.vue";
export default {
  components: { BackButton, Buttons, CurrencyToggle, WatchlistModal, Disclaimer, EditWatchlistModal, PageHelp, AdsGoogle, AdsPartner },
    name: 'Watchlist',
    props: {

    },
    data(){
        return{
            listBenchmark: [],
            currentWatchlist: {},
            selectedFund: [],
            isModalCreatedWatchlist: false,
            isModalEditWatchlist: false,
            sorting1: this.$store.state.watchlist.order1,
            sorting2: this.$store.state.watchlist.order2,
            showSecondOption: this.$store.state.watchlist.showSecondOption,
            isCardModalActive: false,
            watchlistLoading: false,
            sortinglist1:[],
            sortinglist2: [],
            sortinglist: [],
            benchmark: {
                CumulativeTotalReturnTD: 'benchmarkTD',
                CumulativeTotalReturn1Year: 'benchmark1Y',
                TotalReturn3Years: 'benchmark3Y',
                TotalReturn5Years: 'benchmark5Y'
            },
            displayFilter: {
                bestCumulativeTotalReturnTD: 'bestNTRYTD',
                bestCumulativeTotalReturn1Year: 'bestNTR1Y',
                bestTotalReturn3Years: 'bestNTR3Y',
                bestTotalReturn5Years: 'bestNTR5Y',
                medianCumulativeTotalReturnTD: 'medianNTRYTD',
                medianCumulativeTotalReturn1Year: 'medianNTR1Y',
                medianTotalReturn3Years: 'medianNTR3Y',
                medianTotalReturn5Years: 'medianNTR5Y',
                rankCumulativeTotalReturnTD: 'rankfundsntrytd',
                rankCumulativeTotalReturn1Year: 'rankfundsntr1y',
                rankTotalReturn3Years: 'rankfundsntr3y',
                rankTotalReturn5Years: 'rankfundsntr5y',
                numCumulativeTotalReturnTD: 'numfundsNTRYTD',
                numCumulativeTotalReturn1Year: 'numfundsNTR1Y',
                numTotalReturn3Years: 'numfundsNTR3Y',
                numTotalReturn5Years: 'numfundsNTR5Y',
                numongoingchargecomp: 'numfundsOGC',
                bestongoingchargecomp: 'bestOGC',
                medianongoingchargecomp: 'medianOGC',
                rankongoingchargecomp: 'rankfundsogc',
                numstandarddev36m: 'numfunds3YSD',
                beststandarddev36m: 'best3YSD',
                medianstandarddev36m: 'median3YSD',
                rankstandarddev36m: 'rankfunds3ysd',
            },
            displaying: {
                code: 'value',
                text: 'Value',
            },
            comboDisplay: [{
                code: 'value',
                text: 'Value',
            },{
                code: 'rank',
                text: 'Position Within Category',
            },{
                code: 'best',
                text: 'Spread To Category Best',
            },{
                code: 'median',
                text: 'Spread To Category Median',
            },
            ],
            defaultSortField: [
                {
                    code: 'FundBasicsName',
                    sortable: true,
                    text: 'Fund Name',
                    defaultSort: 'ASC'
                },
                {
                    code: 'PriceCurrency',
                    sortable: true,
                    text: 'Ccy',
                    defaultSort: 'DESC'
                }
            ],
            sortingType1: this.$store.state.watchlist.sortingType1,
            sortingType2: this.$store.state.watchlist.sortingType2,
            noAvailabledFund: "",
            sortDir1: this.$store.state.watchlist.sortDir1,
            sortDir2: this.$store.state.watchlist.sortDir2,
            currencyNative : "",
            selected_fs : {
                selected_f1 : { text: 'GBP net assets', code: 'fundnetassetgbp'},
                selected_f2 : { text: 'Yield', code: 'yield12m'},
                selected_f3 : { text: 'OGC', code: 'ongoingchargecomp'},
                selected_f4 : { text: 'NTR YTD', code: 'CumulativeTotalReturnTD'},
                selected_f5 : { text: 'NTR 3Y', code: 'TotalReturn3Years'},
            },
            available_fields : [
                { text: 'Net Assets', code: 'fundnetassetgbp'},
                { text: 'Yield', code: 'yield12m'},
                { text: 'Premium/Discount', code: 'discounttoNAV'},
                { text: 'OGC', code: 'ongoingchargecomp'},
                { text: 'Risk Rating', code: 'riskrating_6M'},
                { text: 'Price', code: 'NAVorClosePrice'},
                { text: 'CCY Hedged', code: 'currencyhedged_all'},
                { text: '3Y SD', code: 'standarddev36m'},
                { text: 'NTR YTD', code: 'CumulativeTotalReturnTD'},
                { text: 'NTR 1Y', code: 'CumulativeTotalReturn1Year'},
                { text: 'NTR 3Y', code: 'TotalReturn3Years'},
                { text: 'NTR 5Y', code: 'TotalReturn5Years'},
                { text: 'Style', code: 'IndexFund'},
                { text: 'Structure', code: 'LegalStructure'},
                { text: 'Asset Manager', code: 'am_short'},
                { text: 'Category', code: 'morningstarcategories'},
                { text: '1 Day Move', code: 'ChangeInPrice'},
                { text: '3Y Sharpe', code: 'sharperatio3Y'},
            ],
            predefinedSortList: [
                {code: "CumulativeTotalReturnTD", defaultSort: 'DESC'},
                {code: "CumulativeTotalReturn1Year", defaultSort: 'DESC'},
                {code: "TotalReturn3Years", defaultSort: 'DESC'},
                {code: "TotalReturn5Years", defaultSort: 'DESC'},
                {code: "FundBasicsName", defaultSort: 'ASC'},
                {code: "fundnetassetgbp", defaultSort: 'DESC'},
                {code: "yield12m", defaultSort: 'DESC'},
                {code: "ongoingchargecomp", defaultSort: 'ASC'},
                {code: "years_since_launch", defaultSort: 'DESC'},
                {code: "manager tenure", defaultSort: 'DESC'},
                {code: "NumberOfHolding", defaultSort: 'DESC'},
                {code: "standarddev36m", defaultSort: 'ASC'},
                {code: "premium/discount to NAV", defaultSort: 'ASC'},
                {code: "CompanyBasicsName", defaultSort: 'ASC'},
                {code: "LegalStructure", defaultSort: 'ASC'},
                {code: "ETF / non ETF", defaultSort: 'ASC'},
                {code: "riskrating_6M", defaultSort: 'ASC'},
                {code: "morningstarcategories", defaultSort: 'ASC'},
                {code: "IndexFund", defaultSort: 'ASC'},
                {code: "am_short", defaultSort: 'DESC'},
                {code: "ongoingchargecomp", defaultSort: 'ASC'},
            ],
            current_fields: [],
            user_id:0,
            ccyDisabled: false,
            tooltipShow:true,
            fundsWithBlogs: [],
            fundsWithNews: [],
        }
    },
    mixins: [commonMixin, compositeMixin, bannerMixin],
    computed: {
        ...mapState('watchlist', {
            myWatchlists: 'myWatchlists',
        })
    },
    watch: {
        '$store.state.auth.authenticated': function (data) {
            if(!data) this.$router.push('/login/max-5')
        },
        '$store.state.auth.emailUser': function (data) {
            if (data) this.getWatchList()

        },
        '$store.state.watchlist.currentWatchlist': async function (value) {
            if(!this.currentWatchlist || Object.keys(value).length && value.id !== this.currentWatchlist.id) {
                await this.$store.dispatch("watchlist/getMyWatchlists");
                const index = this.$store.state.watchlist.myWatchlists.findIndex(watchlist => watchlist.id === this.$store.state.watchlist.currentWatchlist.id);
                this.currentWatchlist = this.$store.state.watchlist.myWatchlists[index];
            }
        },
        sorting1:async function(value) {
            if (value.code === 'CompanyBasicsName' ||
                    value.code === 'LegalStructure' ||
                    value.code === 'am_short' ||
                    value.code === 'ETF / non ETF' ||
                    value.code === 'riskrating_6M' ||
                    value.code === 'IndexFund' ||
                    value.code === 'FundBasicsName' ||
                    value.code === 'PriceCurrency' ||
                    value.code === 'morningstarcategories'
                ) {
                    this.showSecondOption = true
                    this.sortingType1 = [
                        { value: 'DESC', text: 'Z-A'},
                        { value: 'ASC', text: 'A-Z'}
                    ]
                } else {
                    this.showSecondOption = false
                    this.sortingType1 = [
                        { value: 'DESC', text: 'High to Low'},
                        { value: 'ASC', text: 'Low to high'},
                    ]
                    this.clearSorting(2)
                }
                this.sortDir1 = value.defaultSort;

            if(Object.keys(value).length !== 0) {
                this.$store.commit("watchlist/SET_SORTING1", value);
                await this.getFundByIdWatchlist(this.currentWatchlist.id, true);
                this.sortinglist2 = this.sortinglist.filter(el => JSON.stringify(el) !== JSON.stringify(value))
            }


        },
        showSecondOption: function(value) {
              this.$store.commit("watchlist/SHOW_SECOND_OPTION", value)
        },
        sorting2:async function(value) {
            if (value.code === 'CompanyBasicsName' ||
                    value.code === 'LegalStructure' ||
                    value.code === 'am_short' ||
                    value.code === 'ETF / non ETF' ||
                    value.code === 'riskrating_6M' ||
                    value.code === 'IndexFund' ||
                    value.code === 'FundBasicsName' ||
                    value.code === 'PriceCurrency' ||
                    value.code === 'morningstarcategories'
                ) {
                    this.sortingType2 = [
                        { value: 'DESC', text: 'Z-A'},
                        { value: 'ASC', text: 'A-Z'}
                    ]
                } else {
                    this.sortingType2 = [
                         { value: 'DESC', text: 'High to Low'},
                        { value: 'ASC', text: 'Low to high'},
                    ]
                }

            this.sortDir2 = value.defaultSort;
            this.$store.commit("watchlist/SET_SORTING2", value);
            await this.getFundByIdWatchlist(this.currentWatchlist.id, true)

            if(Object.keys(value).length !== 0) {
                this.sortinglist1 = this.sortinglist.filter(el => JSON.stringify(el) !== JSON.stringify(value))
            }
        },
        sortingType1: function (value) {
            this.$store.commit("watchlist/SET_SORTING_TYPE1", value)
        },
        sortingType2: function (value) {
            this.$store.commit("watchlist/SET_SORTING_TYPE2", value)
        },
        sortDir1:async function(value) {
            if (value) {
                this.$store.commit("watchlist/SET_SORT_DIR1", value)
                await this.getFundByIdWatchlist(this.currentWatchlist.id, true)
            }
        },
        sortDir2:async function(value) {
            if (value) {
                this.$store.commit("watchlist/SET_SORT_DIR2", value)
                await this.getFundByIdWatchlist(this.currentWatchlist.id, true)
            }
        },
        currentWatchlist: function(value) {
            if(value && value.id) {
                if(value.id !== this.$store.state.watchlist.currentWatchlist.id) {
                    this.clearSorting(2)
                    this.clearSorting(1)
                }
                this.getFundByIdWatchlist(value.id, true)
                this.$store.commit("watchlist/SET_CURRENT_WATCHLIST", value)
            }

        }
    },
    filters: {
        numbersformat(labelValue, code){
            const typeText = ['morningstarcategories', 'am_short', 'LegalStructure', 'IndexFund', 'riskrating_6M', 'NAVorClosePrice'];
            const typeIndexFund = ['IndexFund'];
            const typeHedged = ['currencyhedged_all'];

            if(typeHedged.includes(code)) return labelValue ? 'Yes' : 'No'
            else if(typeIndexFund.includes(code)) return labelValue ? 'Passive' : 'Active'
            else if(typeText.includes(code)) return labelValue;
            else return parseFloat(labelValue).toFixed(2)
        },
        stringFormat(code){
            if ( code == 'IT'|| code == 'OEIC'|| code == 'SICAV' || code == 'UT') {
                return code
            } else {
                let matches = code.match(/\b(\w)/g)
                let acronym = matches.join('')
                return acronym
            }

        },
        findUnit(code) {
            const unitPercent = ['yield12m', 'discounttoNAV', 'ongoingchargecomp', 'standarddev36m', 'CumulativeTotalReturnTD', 'CumulativeTotalReturn1Year', 'TotalReturn3Years', 'TotalReturn5Years', 'ChangeInPrice'];
            if(unitPercent.includes(code)) return '%';
        }
    },
    methods:{
        getBlog(fund_id) {
            axios.get('/fund-blogs/'+fund_id)
            .then((response) => {
                this.fundsWithBlogs = response.data
            })
        },
        getNews(fund_id) {
            axios.get('/fund-news/'+fund_id)
            .then((response) => {
                this.fundsWithNews = response.data
            })
        },
        changeBenchmark(id, isin, bmark) {
            var isin_benchmark = '';
            if(!bmark) {
                this.$refs[id][0].textContent = "Select B'mark";
                this.$refs['buttonBenchmark_' + isin.ISIN][0].classList.add("btn-default");
                for(let n = 1; n <= 5; n++) {
                    this.$refs[isin.ISIN + 'benchmark_f' + n][0].textContent = '';
                }
            } else {
                this.$refs['buttonBenchmark_' + isin.ISIN][0].classList.remove("btn-default");
                isin_benchmark = bmark.ISIN;
                this.$refs[id][0].textContent = bmark.description;
                for(let n = 1; n <= 5; n++) {
                    if ([
                            'CumulativeTotalReturn1Year', 
                            'CumulativeTotalReturnTD', 
                            'TotalReturn3Years', 
                            'TotalReturn5Years'
                        ].includes(this.selected_fs['selected_f'+n].code) && this.displaying.code === 'value') {
                        let $el = this.$refs[isin.ISIN + 'benchmark_f' + n][0];
                        if (isin[this.selected_fs['selected_f'+n].code] == null) {
                            $el.textContent =  '';
                        } else {
                            let benchmarkValue = parseFloat(isin[this.selected_fs['selected_f'+n].code] - bmark[this.benchmark[this.selected_fs['selected_f'+n].code]]);
                            if (benchmarkValue > 0) {
                                $el.classList.remove("red");
                                $el.classList.add("dark-text");
                            } else {
                                $el.classList.remove("dark-text");
                                $el.classList.add("red");
                            }
                            $el.textContent =  benchmarkValue.toFixed(2) + '%';
                        }
                    }
                }
            }
            
            axios.get('/save-isin-benchmark-chosen', {params:{
                isin_benchmark,
                fund_id: isin.fund_id,
                watchlist_id: this.currentWatchlist.id
            }})
            var list = document.querySelectorAll("#dropdown-sprd-vs");
            var listDefaultBenchmark = document.querySelectorAll("#dropdown-sprd-vs .btn-default");
            this.ccyDisabled = list.length > listDefaultBenchmark.length
            if (this.ccyDisabled && this.$store.state.search.currency != 'gbp') {
                this.$store.commit("search/SET_CURRENCY", 'gbp')
                this.currencyChange()
            }
        },
        async getBenchmark(){
            var self = this;
            await axios.get(`/comparebenchmark`)
                .then(async (response) => {
                    if (response) {
                        self.listBenchmark = response.data;
                    }
                })
                .catch(() => {});
        },
        async getWatchList (){
            await this.$store.dispatch("watchlist/getMyWatchlists");
            if (this.$store.state.watchlist.myWatchlists.length) {
                this.currentWatchlist = this.$store.state.watchlist.myWatchlists[0];
                if(this.currentWatchlist) await this.getFundByIdWatchlist(this.currentWatchlist.id, true)
            }
        },
        addNewFundClick () {
            this.$router.push({name:"Home", params: {selectedWatchlistID: this.currentWatchlist.id}})
        },
        createWatchClick() {
            if (this.myWatchlists.length < 5) {
                this.isModalCreatedWatchlist = !this.isModalCreatedWatchlist
            } else {
                this.$toast.error('You can only create 5 Watchlists!')
            }
        },
        removeWatchlist(watchlist) {
            this.$buefy.dialog.confirm({
                type: 'is-danger',
                hasIcon: true,
                message: 'Delete Watchlist?',
                onConfirm: async () => {
                    await axios.delete(`/watchlist/${watchlist.id}`)
                    await this.$store.dispatch("watchlist/getMyWatchlists")
                    this.currentWatchlist = this.$store.state.watchlist.myWatchlists[0];
                }
            })
        },
        scrollToFundList() {
            const scrollToFundListBtn = document.getElementById('scrollToFundListBtn');
            scrollToFundListBtn.click()
        },
        change_field(fid,obj){
            if (fid !== 6) {
                if (this.sorting1.code != obj.code) {
                    this.sorting1 = obj
                }
                if(fid==1){
                    this.selected_fs.selected_f1 = obj;
                }
                if(fid==2){
                    this.selected_fs.selected_f2 = obj;
                }
                if(fid==3){
                    this.selected_fs.selected_f3 = obj;
                }
                if(fid==4){
                    this.selected_fs.selected_f4 = obj;
                }
                if(fid==5){
                    this.selected_fs.selected_f5 = obj;
                }
                
            }
            this.filterAvailableField();

            const saveAttributes = [this.selected_fs.selected_f1.code, this.selected_fs.selected_f2.code,this.selected_fs.selected_f3.code
                                    , this.selected_fs.selected_f4.code, this.selected_fs.selected_f5.code];
            this.getFundByIdWatchlist(this.currentWatchlist.id, true, saveAttributes)
        },
        filterAvailableField() {
            if(this.available_fields && this.available_fields.length) {
                this.current_fields = this.available_fields.filter(el => el.code !== this.selected_fs.selected_f1.code
                && el.code !== this.selected_fs.selected_f2.code
                && el.code !== this.selected_fs.selected_f3.code
                && el.code !== this.selected_fs.selected_f4.code
                && el.code !== this.selected_fs.selected_f5.code)
            }
        },
        async getFundByIdWatchlist(id, isReload, saveAttributes) {
            // if(!id) return;
            this.noAvailabledFund="Please wait..."
            if (!this.watchlistLoading) {
                this.watchlistLoading = true
                this.selectedFund = [];

                await axios.post(`/watchlist/${id}`, {
                    native: this.$store.state.search.currency,
                    order1: this.sorting1.code!=='' ? this.sorting1.code : undefined,
                    order2: this.sorting2.code!=='' ? this.sorting2.code : undefined,
                    dir1: this.sortDir1,
                    dir2: this.sortDir2,
                    settings: saveAttributes
                }).then(res => {
                    this.$store.commit("watchlist/SET_SEARCH_WATCHLIST", res.data.data)
                    this.selectedFund = res.data.data.items;
                    if(isReload) {
                        this.sortinglist2=this.sortinglist1=this.sortinglist = [
                        ...res.data.data.settings.map(setting => ({
                            ...setting,
                            defaultSort: "DESC",
                            ...this.predefinedSortList.find(({code}) => code === setting.code)
                        })).concat(this.defaultSortField)];
                        this.selected_fs.selected_f1 = res.data.data.settings[0];
                        this.selected_fs.selected_f2 = res.data.data.settings[1];
                        this.selected_fs.selected_f3 = res.data.data.settings[2];
                        this.selected_fs.selected_f4 = res.data.data.settings[3];
                        this.selected_fs.selected_f5 = res.data.data.settings[4];
                        this.filterAvailableField();
                        this.watchlistLoading = false;
                    }
                    if (!this.selectedFund.length)
                        this.noAvailabledFund="Your Watchlist is currently empty."
                }).catch(err => {
                    this.watchlistLoading = false
                    if (err.response.status == 400) {
                    this.noAvailabledFund=""
                    }
                });
                this.updateListDropdownBenchmark();
            }
        },
        updateListDropdownBenchmark(){
            var updateBenmarkButton = true;
            for(let n = 1; n < 6; n++) {
                    if ([
                        'CumulativeTotalReturn1Year', 
                        'CumulativeTotalReturnTD', 
                        'TotalReturn3Years', 
                        'TotalReturn5Years'
                    ].includes(this.selected_fs['selected_f'+n].code)) {
                        updateBenmarkButton = false;
                        break;
                    }
                }
            updateBenmarkButton = updateBenmarkButton || this.displaying.code !== "value";
            var list = document.querySelectorAll("#dropdown-sprd-vs");
            var listDefaultBenchmark = document.querySelectorAll("#dropdown-sprd-vs .btn-default");
            if (updateBenmarkButton) {
                for (let i = 0; i < list.length; ++i) {
                    list[i].classList.add('btn-disabled');
                }
            } else {
                for (let i = 0; i < list.length; ++i) {
                    list[i].classList.remove('btn-disabled');
                }
            }
            this.ccyDisabled = list.length > listDefaultBenchmark.length;
            if (this.ccyDisabled && this.$store.state.search.currency != 'gbp') {
                this.$store.commit("search/SET_CURRENCY", 'gbp')
                this.currencyChange()
            }
        },
        changeCurrentWatchlist(watchlist) {
            this.scrollToFundList()
            this.currentWatchlist = watchlist
            this.sorting1 = {};
            this.$store.commit("watchlist/SET_SORTING1", {});
            this.sorting2 = {};
            this.$store.commit("watchlist/SET_SORTING2", {});

        },
        currencyChange() {
            this.getFundByIdWatchlist(this.currentWatchlist.id, true)
        },
        acronymSentence(str) {
            let matches = str.match(/\b(\w)/g)
            let acronym = matches.join('')
            return acronym
        },
        clearSorting(level) {
            switch(level) {
                case 1: {
                    this.sorting1 = {
                        code: 'FundBasicsName',
                        sortable: true,
                        text: 'Fund Name'
                    }
                    this.sortDir1 = 'DESC'
                }
                break;
                case 2: {
                    this.sorting2 = {}
                    this.sortDir2 = 'DESC'
                }
                break;
                default:
                break;
            }
        },
        checkNTRs(selected_f){
            let ar = [
                'CumulativeTotalReturnTD',
                'CumulativeTotalReturn1Year',
                'CumulativeTotalReturn3Years',
                'CumulativeTotalReturn5Years',
                'TotalReturn3Years',
                'TotalReturn5Years',
                'ongoingchargecomp',
                'standarddev36m'


            ];
            return ar.includes(selected_f) && this.displaying.code !== 'value'
        },
    },
    async created() {
        window.addEventListener('scroll', this.handleScroll);
        this.$store.commit('compare/SET_TYPE_COMPARE_DETAIL', 'watchlist_page');
        this.getWatchList()
        if(Object.keys(this.$store.state.watchlist.currentWatchlist).length) {
            // await this.getFundByIdWatchlist(this.$store.state.watchlist.currentWatchlist.id, true);
            const index = this.$store.state.watchlist.myWatchlists.findIndex(watchlist => watchlist.id === this.$store.state.watchlist.currentWatchlist.id);
            this.currentWatchlist = this.$store.state.watchlist.myWatchlists[index];
        } else {
            this.currentWatchlist = this.$store.state.watchlist.myWatchlists[0];
            if(this.currentWatchlist) await this.getFundByIdWatchlist(this.currentWatchlist.id, true)
        }
        await this.getBenchmark();
        this.filterAvailableField();
    },
    mounted() {
        if (this.$router.currentRoute.params.watchlistID) {
            this.getFundByIdWatchlist(this.$router.currentRoute.params.watchlistID, true)
        }
        if (!this.sorting1.text) {
            this.sorting1 = {
                code: 'FundBasicsName',
                sortable: true,
                text: 'Fund Name',
                defaultSort: 'ASC'
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    metaInfo() {
        return {
            title: "My Watchlists | Pickafund",
            meta: [
                { name: 'description', content:  'Create a watchlist for instant assets and monitoring of your chosen Funds.'},
                /*{ property: 'og:title', content: "Epiloge - Build your network in your field of interest"},
                */
            ]
        }
    }
}

</script>




